import { call, put, select, takeLatest } from 'redux-saga/effects';
import { approvalStateActions, fetchApprovalCustomerListDataCreatorTypeName, fetchApprovalDataCreatorTypeName, fetchApprovalsLandingFilterDataTypesName,fetchMarkCampaignAsCompleteCreatorTypeName } from './slice';
import { API_PATH, TOAST_MESSAGES } from '@app/common/constants';
import { NetworkService } from '@app/services';
import { showEngagementErrors, successToast } from '../../setup-engagement-module/setup-engagement-screens/engagementConfig';
import { approvalStateSelector } from './selectors';
import { transformApiDataToFilters } from '@app/helper/campaign-management';
import { filterSelector, filterStateActions } from '@app/components/right-sidebar/redux';

/**
 * fetch ApprovalData Watcher
*/
export function* fetchApprovalDataWatcher() {
  yield takeLatest(
    fetchApprovalDataCreatorTypeName,
    fetchApprovalDataWatcherWorker,
  );
}

/**
 * fetch ApprovalCustomerList Watcher
 */
export function* fetchApprovalCustomerListDataWatcher() {
  yield takeLatest(
    fetchApprovalCustomerListDataCreatorTypeName,
    fetchApprovalCustomerListDataWatcherWorker,
  );
}

/**
 * fetch Approvals Landing Filter Watcher
*/
export function* fetchApprovalsLandingFilterDataWatcher() {
  yield takeLatest(
    fetchApprovalsLandingFilterDataTypesName,
    fetchApprovalsLandingFilterDataWorker,
  );
}

/*
fetch Mark Campaign As Complete Watcher
*/
export function* fetchMarkCampaignAsCompleteWatcher() {
  yield takeLatest(
    fetchMarkCampaignAsCompleteCreatorTypeName,
    fetchMarkCampaignAsCompleteWorker,
  );
}


/**
 * fetch ApprovalData Worker
 */
export function* fetchApprovalDataWatcherWorker(action: any): any {
  try {
    if (
      action &&
      action.payload &&
      Object.keys(action.payload).length > 0 &&
      typeof action.payload.url !== 'undefined'
    ) {
      if (
        action.payload.url === 'approvals/category' &&
        typeof action.payload.staffPositionId !== 'undefined'
      ) {
        const url = `${API_PATH.setupEngagement.approvalData}/${action.payload.url}`;
        
        // Get applied campaign filter from approval Redux state
        const appliedCampaignFilter = yield select(approvalStateSelector.getAppliedCampaignFilter());
        
        // Get pagination state from Redux
        const paginationState = yield select(approvalStateSelector.getCategoryPaginationState());
        
        // Extract campaignId from applied filter
        const selectedCampaignId = appliedCampaignFilter?.campaignList?.[0]?.campaignId;
        
        // Use selected campaign or fallback to 105
        const campaignId = selectedCampaignId;
        
        
        // Build request payload with selected campaign and pagination
        const requestPayload = {
          campaignId: campaignId,
          isMrShow: false,
          pageNo: action.payload.pagination?.pageNo || paginationState.pageNo,
          pageSize: action.payload.pagination?.pageSize || paginationState.pageSize
        };

        const categoryData = yield call(NetworkService.post, url, requestPayload, {});
        if (categoryData.status === 200) {
          yield put(approvalStateActions.setLoaderData({ isLoading: false }));
          yield put(
            approvalStateActions.setApprovalData({
              categoryData: categoryData?.data,
            }),
          );
          // Store total count if available in response (adjust path based on actual API response structure)
          if (categoryData?.data?.totalCount !== undefined) {
            yield put(approvalStateActions.setCategoryTotalCount(categoryData.data.totalCount));
          } else if (Array.isArray(categoryData?.data)) {
            // If no totalCount in response, use array length as fallback
            yield put(approvalStateActions.setCategoryTotalCount(categoryData.data.length));
          }
        } else {
          yield put(approvalStateActions.setLoaderData({ isLoading: false }));
          yield put(
            approvalStateActions.setApprovalData({
              categoryData: [],
            }),
          );
          yield put(approvalStateActions.setCategoryTotalCount(0));
          showEngagementErrors(categoryData?.data?.error);
        }
      } else if (
        action.payload.url === 'approvals/speciality' &&
        typeof action.payload.staffPositionId !== 'undefined'
      ) {
        const url = `${API_PATH.setupEngagement.approvalData}/${action.payload.url}`
        
        // Get applied campaign filter from approval Redux state
        const appliedCampaignFilter = yield select(approvalStateSelector.getAppliedCampaignFilter());
        
        // Get pagination state from Redux
        const paginationState = yield select(approvalStateSelector.getSpecialityPaginationState());
        
        // Extract campaignId from applied filter
        const selectedCampaignId = appliedCampaignFilter?.campaignList?.[0]?.campaignId;
        
        // Use selected campaign or fallback to 105
        const campaignId = selectedCampaignId || 105;
        
        
        // Build request payload with selected campaign and pagination
        const requestPayload = {
          campaignId: campaignId,
          isMrShow: false,
          pageNo: action.payload.pagination?.pageNo || paginationState.pageNo,
          pageSize: action.payload.pagination?.pageSize || paginationState.pageSize
        };
        
        const specialityData = yield call(NetworkService.post, url, requestPayload, {});
        if (specialityData.status === 200) {
          yield put(approvalStateActions.setLoaderData({ isLoading: false }));
          yield put(
            approvalStateActions.setApprovalData({
              specialityData: specialityData?.data,
            }),
          );
          // Store total count if available in response
          if (specialityData?.data?.totalCount !== undefined) {
            yield put(approvalStateActions.setSpecialityTotalCount(specialityData.data.totalCount));
          } else if (Array.isArray(specialityData?.data)) {
            // If no totalCount in response, use array length as fallback
            yield put(approvalStateActions.setSpecialityTotalCount(specialityData.data.length));
          }
        } else {
          yield put(approvalStateActions.setLoaderData({ isLoading: false }));
          yield put(
            approvalStateActions.setApprovalData({
              specialityData: [],
            }),
          );
          yield put(approvalStateActions.setSpecialityTotalCount(0));
          showEngagementErrors(specialityData?.data?.error);
        }
      } else if (
        action.payload.url === 'approvals/showlist' &&
        typeof action.payload.engagementId !== 'undefined' &&
        typeof action.payload.staffpositionId !== 'undefined'
      ) {
        const showListFilterUrl = `${API_PATH.setupEngagement.engagementFilterApprovals}`;
        const showListFilters = yield call(NetworkService.get, showListFilterUrl, {}, {});
        if(showListFilters.status === 200){
          const transformedFilters = transformApiDataToFilters(showListFilters?.data);
          yield put(filterStateActions.setFilterState(transformedFilters));
        }
        const url = `${API_PATH.setupEngagement.approvalData}/${action.payload.url}?engagementId=${action.payload.engagementId}&staffpositionId=${action.payload.staffpositionId}`;
        const defaultPayload = {
          "approvalStatus": [
            {
              "approvalStatusId": 2
            }
          ],
          // "completionStatus": [
          //   {
          //     "completionStatusId": 0,
          //     "completionStatusName": ""
          //   }
          // ],
          // "countries": [
          //   {
          //     "countryId": 0,
          //     "countryName": ""
          //   }
          // ],
          // "states": [
          //   {
          //     "stateId": 0,
          //     "stateName": ""
          //   }
          // ],
          // "hQs": [
          //   {
          //     "headQuaterId": 0,
          //     "headQuaterName": ""
          //   }

          // ],
          // "divisions": [
          //   {
          //     "divisionId": 0,
          //     "divisionName": ""
          //   }
          // ],
          "minDMS": 0,
          "maxDMS": 10000000,
          "minDM": 0,
          "maxDM": 100000000,
          "minSOW": 0,
          "maxSOW": 1000,
          "engagementId": action.payload.engagementId,
          "staffPositionId": action.payload.staffpositionId,
          "pageNo": action.payload.pagination?.pageNo || 1,
          "pageSize": action.payload.pagination?.pageSize || 10
        }

        const filtersPayload = yield select(filterSelector.getFilterState());
        // the firstMount defaultPayload
        if(!action?.payload?.filters){

        }
        const showListData = yield call(
          NetworkService.post, 
          url, 
          action?.payload?.filters ? action?.payload?.filters : defaultPayload, 
          {}
        );
        if (showListData.status === 200) {
          yield put(approvalStateActions.setLoaderData({ isLoading: false }));
          yield put(
            approvalStateActions.setApprovalData({
              showListData: showListData?.data?.data,
              showListResponse: showListData?.data?.data,
            }),
          );
        } else {
          yield put(approvalStateActions.setLoaderData({ isLoading: false }));
          yield put(
            approvalStateActions.setApprovalData({
              showListData: [],
              showListResponse: [],
            }),
          );
          showEngagementErrors(showListData?.data?.error);
        }
      } else if (
        action.payload.url === 'approvals/history' &&
        typeof action.payload.engagementId !== 'undefined' &&
        typeof action.payload.staffpositionId !== 'undefined'
      ) {
        const url = `${API_PATH.setupEngagement.approvalData}/${action.payload.url}?engagementId=${action.payload.engagementId}&staffpositionId=${action.payload.staffpositionId}`;
        const approvalHistoryData = yield call(NetworkService.get, url, {}, {});
        if (approvalHistoryData.status === 200) {
          yield put(approvalStateActions.setLoaderData({ isLoading: false }));
          yield put(
            approvalStateActions.setApprovalData({
              approvalHistoryData: approvalHistoryData?.data,
            }),
          );
        } else {
          yield put(approvalStateActions.setLoaderData({ isLoading: false }));
          yield put(
            approvalStateActions.setApprovalData({
              approvalHistoryData: [],
            }),
          );
          showEngagementErrors(approvalHistoryData?.data?.error);
        }
      } else if (
        action.payload.url === 'engagementslistbyparty' &&
        typeof action.payload.partyId !== 'undefined'
      ) {
        const url = `${API_PATH.setupEngagement.approvalData}/${action.payload.url}?partyId=${action.payload.partyId}`;
        const engagementsList = yield call(NetworkService.get, url, {}, {});
        if (engagementsList.status === 200) {
          yield put(approvalStateActions.setLoaderData({ isLoading: false }));
          yield put(
            approvalStateActions.setApprovalData({
              engagementsList: engagementsList?.data,
            }),
          );
        } else {
          yield put(approvalStateActions.setLoaderData({ isLoading: false }));
          yield put(
            approvalStateActions.setApprovalData({
              engagementsList: [],
            }),
          );
          showEngagementErrors(engagementsList?.data?.error);
        }
      }
      else if (
        action.payload.url === 'engagement/wsfacodes' &&
        typeof action.payload.staffPositionIds !== 'undefined'
      ) {
        const url = `${API_PATH.setupEngagement.approvalData}/${action.payload.url}?staffPositionIds=${action.payload.staffPositionIds}`;
        const approvalwsfaCodesData = yield call(NetworkService.get, url, {}, {});

        if (approvalwsfaCodesData.status === 200) {
          yield put(approvalStateActions.setLoaderData({ isLoading: false }));
          yield put(
            approvalStateActions.setApprovalwsfaCodes(approvalwsfaCodesData?.data),
          );
        } else {
          yield put(approvalStateActions.setLoaderData({ isLoading: false }));
          yield put(
            approvalStateActions.setApprovalwsfaCodes([]),
          );
          showEngagementErrors(approvalwsfaCodesData?.data?.error);
        }
      }
      else if (
        action.payload.url === 'approvals/status' &&
        typeof action.payload.isApprove !== 'undefined'
      ) {
        const approvalStatusData = yield select(approvalStateSelector.getApprovalStatusData())
        const url = `${API_PATH.setupEngagement.approvalData}/${action.payload.url}?isApprove=${action.payload.isApprove}`;
        const responseData = yield call(
          NetworkService.post,
          url,
          approvalStatusData,
        );
        yield put(
          approvalStateActions.setApprovalStatusResponseData(responseData),
        );

        if (action.payload.isApprove) {
          successToast(TOAST_MESSAGES.SUCCESSFULLY_ADD_DOCTORS)
        } else {
          successToast(TOAST_MESSAGES.SUCCESSFULLY_REJECT_DOCTORS)
        }

        if (responseData?.status === 200) {
          yield put(approvalStateActions.setApprovalData({ isApproved: false }));
          yield put(approvalStateActions.setApprovalCustomerListResponseData({}));
        } else {
          yield put(approvalStateActions.setLoaderData({ isLoading: false }));
          showEngagementErrors(responseData?.data?.error);
        }
      } else {
        yield put(approvalStateActions.setLoaderData({ isLoading: false }));
        throw new Error();
      }
    }
  } catch (error) {
    yield put(approvalStateActions.setLoaderData({ isLoading: false }));
    console.error(error);
  }
}


/**
 * fetch ApprovalCustomerList Worker
 */
export function* fetchApprovalCustomerListDataWatcherWorker(action: any): any {
  try {
    const payload = action.payload;
    
    const url = `${API_PATH.setupEngagement.saveAdoptedCustomers}`;
    const responseData = yield call(
      NetworkService.post,
      url,
      payload,
    );
    if (responseData?.status === 200) {
      yield put(
        approvalStateActions.setApprovalCustomerListResponseData(responseData?.data),
      );
      yield put(
        approvalStateActions.setApprovalData({
          wsfaData: [],
        }),
      );
    } else {
      yield put(approvalStateActions.setLoaderData({ isLoading: false }));
      showEngagementErrors("Failed to save the data");
    }
  } catch (error) {
    console.log(error);
  }
}

/**
 * fetch Approvals Landing Filter Data Worker
 */
export function* fetchApprovalsLandingFilterDataWorker(): any {
  try {
    // yield put(setLoading(true));
    const engagementFilterUrl = API_PATH.setupEngagement.engagementFilterCampaigns;
    yield put(approvalStateActions.setLoaderData({ isLoading: true }));
    const fetchData = async (url: string, params: any = {}) => {
      const res = await NetworkService.get(url, params, {});
      return res.status === 200 ? res.data : [];
    };
    /**
     * Fetches the list of campaigns.
     * @returns Object containing campaign filter data.
     */
    // Read currently applied campaign filter once per worker run
    const currentAppliedFilter = yield select(approvalStateSelector.getAppliedCampaignFilter());
    const appliedCampaignId = currentAppliedFilter?.campaignList?.[0]?.campaignId;

    const fetchCampaigns = async () => {
      const campaignData = await fetchData(engagementFilterUrl);

      const campaignFilterData = campaignData.map((campaign: any) => ({
        value: campaign.campaignName,
        id: campaign.campaignId,
      }));

      if (campaignFilterData.length > 0) {
        // If we already have an applied campaign, reflect it in the filter list
        if (appliedCampaignId) {
          const matchIndex = campaignFilterData.findIndex((c: any) => c.id === appliedCampaignId);
          if (matchIndex !== -1) {
            campaignFilterData[matchIndex].isChecked = true;
          }
        }
        // Fallback: if after attempting to mark applied campaign none are checked, select first
        if (!campaignFilterData.some((item: any) => item.isChecked)) {
          campaignFilterData[0].isChecked = true;
        }
      }

      return {
        'Campaign Name': {
          filterData: campaignFilterData,
          collapsed: true,
          isChecked: false,
        },
      };
    };
    const fetchOptions = async () => {
      const campaigns = await fetchCampaigns();

      return {
        ...campaigns,
      };
    };

    const option = yield call(fetchOptions);
    yield put(approvalStateActions.setApprovalsLandingFilterData(option));
    
    // Auto-apply first campaign filter ONLY if no filter is currently applied
    // This prevents overwriting user's selection when switching tabs
    // Reuse previously fetched applied campaign filter to avoid redeclaration

    
    if (!currentAppliedFilter || Object.keys(currentAppliedFilter).length === 0) {
      const firstCampaign = option['Campaign Name']?.filterData?.[0];
      if (firstCampaign) {
        const autoAppliedFilter = {
          campaignList: [{ campaignId: firstCampaign.id }],
          statusList: [{ statusId: 1 }], // Pending
          leaveTypeList: [],
          stateList: [],
          divisionList: [],
          userStatusList: [
            {
              userStatus: 1, //for active
            },
          ],
        };
        // Use approval module's own action instead of leave management
        yield put(approvalStateActions.setAppliedCampaignFilter(autoAppliedFilter));
      }
    }
    
    yield put(approvalStateActions.setLoaderData({ isLoading: false }));
  } catch (error) {
    // yield put(setLoading(false));
    yield put(approvalStateActions.setLoaderData({ isLoading: false }));
    console.error('Error fetching Campaign names:', error);
  }
}


/*
fetch Mark Campaign As Complete Worker
*/
export function* fetchMarkCampaignAsCompleteWorker(action: any): any {
  try {
    
    if (action?.payload?.engagementId) {
      const url = `${API_PATH.setupEngagement.completeEngagement}?engagementId=${action.payload.engagementId}`;
      yield put(approvalStateActions.setLoaderData({ 
        isLoading: true, 
        mssg: 'Marking campaign as complete...' 
      }));
      
      const responseData = yield call(NetworkService.post, url, {}, {});
      
      if (responseData?.status === 200) {
        yield put(approvalStateActions.setLoaderData({ isLoading: false }));
        
        // Check if response data contains success message
        const responseText = typeof responseData?.data === 'string' 
          ? responseData.data 
          : responseData?.data?.message || '';
        
        if (responseText.includes('status updated as Completed')) {
          // Success case - show success toast and navigate
          successToast('Campaign marked as complete successfully!');
          yield put(approvalStateActions.setShouldNavigateToApproval(true));
        } else {
          // Status 200 but different message - show the actual message as error
          showEngagementErrors(responseText || 'Campaign status could not be updated');
        }
      } else {
        yield put(approvalStateActions.setLoaderData({ isLoading: false }));
        showEngagementErrors(responseData?.data?.error || 'Failed to mark campaign as complete');
      }
    } else {
      yield put(approvalStateActions.setLoaderData({ isLoading: false }));
      showEngagementErrors('Engagement ID is required');
    }
  } catch (error) {
    yield put(approvalStateActions.setLoaderData({ isLoading: false }));
    showEngagementErrors('An error occurred while marking campaign as complete');
    console.error('Error in Mark As Complete:', error);
  }
}